import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../../customerspages.service';
import { HubspotCustomFormService } from 'src/app/shared/services/hubspot-custom-form.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-case-study-api',
  templateUrl: './case-study-api.component.html',
  styleUrls: ['./case-study-api.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class CaseStudyApiComponent implements OnInit, OnChanges, OnDestroy {
  @Input() artData: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private customersPagesService: CustomerspagesService,
    private customFormService: HubspotCustomFormService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  apiData: any;
  downloadableFiles: any;
  formSubmitted: boolean = false;

  ngOnInit(): void {}
  ngOnChanges(): void {
      const data = this.artData;
      if (data != null) {
        this.apiData = {
          logo: {
            url: data?.clientLogoIcon?.fields?.file?.url || '',
            alt: data?.clientLogoIcon?.fields?.title || '',
          },
          productsUsed: {
            header: data?.productsUsedComponent?.fields?.title || '',
            bullets: data?.productsUsedComponent?.fields?.components || [],
          },
          categoryTags: data?.categoryTags || [],
          articleContent: data?.articleContent,
          psCustomerStoryPdf: data?.psCustomerStoryPdf,
        };
        if (data?.psCustomerStoryPdf) {
          this.apiData.psCustomerStoryPdf = data?.psCustomerStoryPdf;
        }
        if (data?.caseStudyLeftContent) {
          this.apiData.caseStudyLeftContent = data?.caseStudyLeftContent;
        }
      }
  }

  ngAfterViewInit() {
    try {
      // @ts-ignore
      hbspt.forms.create({
        region: 'na1',
        portalId: '8646839',
        formId: 'b80370b9-3377-4553-92ce-087fd9cd04b1',
        target: '#hubspotformCustomerStory',
        onFormReady: ($form: any) => {
          this.customFormService.generateCustomFormStyle($form);
        },
        onFormSubmit: ($form: any) => {
          const isServer = !isPlatformBrowser(this.platformId);
          if (isServer) return;
          this.apiData?.psCustomerStoryPdf.forEach((el:any) => {
            const fileUrl = el?.fields?.file?.url;
            window.open(`http:${fileUrl}`);
          });
        },
      });
    } catch (_) {}
  }
}
